import store from "@/store";

import dateFormatter from "@/services/formatter_services/date-formatter";
const WHITE_SPACES = /\s+/g;

/**
 * @param {string} dataUrl
 * @param {string} fileName
 * @returns {Promise<File>}
 */
export default async function base64ToFile(dataUrl, fileName = undefined) {
    if (!fileName) { fileName = _getDefaultFileName(dataUrl); }
    else {
        let fileEnding = _getFileEnding(dataUrl);
        fileName = `${fileName}${fileEnding}`;
    }

    const fileType = _getFileType(dataUrl);

    let res = await fetch(`data:${fileType};base64,${dataUrl}`);
    const blob = await res.blob();
    return new File([blob], fileName, { type: fileType });
}

const _getFileType = (base64String) => {
    var data = base64String.substring(0, 5);
    switch (data.toUpperCase()) {
        case "IVBOR":
            return "image/png";
        case "/9J/4":
            return "image/jpeg";
        // case "AAAAI":
        //     return "mp4";
        case "JVBER":
            return "application/pdf";
        // case "AAABA":
        //     return "ico";
        case "UMFYI":
            return "application/vnd.rar";
        // case "E1XYD":
        //     return "rtf";
        case "U1PKC":
            return "text/plain";
        // case "MQOWM":
        // case "77U/M":
        //     return "srt";
        default:
            return data ? ("." + data) : "";
    }
}

const _getFileEnding = (base64String) => {
    var data = base64String.substring(0, 5);
    switch (data.toUpperCase()) {
        case "IVBOR":
            return ".png";
        case "/9J/4":
            return ".jpg";
        case "AAAAI":
            return ".mp4";
        case "JVBER":
            return ".pdf";
        case "AAABA":
            return ".ico";
        case "UMFYI":
            return ".rar";
        case "E1XYD":
            return ".rtf";
        case "U1PKC":
            return ".txt";
        case "MQOWM":
        case "77U/M":
            return ".srt";
        default:
            return data ? ("." + data) : "";
    }
}

const _getDefaultFileName = (dataUrl) => {
    let userName = _getFormattedUserName();
    let today = _getFormattedToday();
    let fileEnding = _getFileEnding(dataUrl);

    return `${today}_${userName}${fileEnding}`;

}

const _getFormattedUserName = () => {
    let { username } = store.getters['actingUser/getActingUserDetails'];
    if (!username) { return '' }

    return username.toLowerCase().replace(WHITE_SPACES, '-');
}

const _getFormattedToday = () => {
    return dateFormatter.formatDate(new Date(), 'YYYY-MM-DD_HHmmss');
}

/**
 * Convert a File to a base64 string
 * @param {File|Blob} input - The input to convert (File, Blob)
 * @returns {Promise<string>} - A promise that resolves to the base64 string
 */
export function fileToBase64(input) {
  return new Promise((resolve, reject) => {
    if (!input) {
      return reject(new Error('Input is null or undefined'));
    }
    if (input instanceof File || input instanceof Blob) {
      const reader = new FileReader();
      reader.onload = () => {
        const base64String = reader.result.split(',')[1];
        resolve(base64String);
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(input);
      return;
    }
    reject(new Error('Unsupported input format for fileToBase64'));
  });
}